import { Button } from "@calcom/ui";
import { FiArrowRight } from "react-icons/fi";
import { useLocale } from "@calcom/lib/hooks/useLocale";
import { ExpertCard } from "@calcom/features/experts/components/ExpertCard";

import type { getExperts } from "@calcom/features/experts/lib/getExperts";
import type { Booking } from "experts/lib/getBookingPropsForExpersIds";

export type ExpertsListProps = {
  header?: string;
  experts: Awaited<ReturnType<typeof getExperts>> | undefined;
  footer?: React.ReactNode;
  booking: Booking;
  expertsNextAvailableSlot: {
    [x: string]: string;
  };
};

export const ExpertsList = ({
  header,
  experts,
  footer,
  booking,
  expertsNextAvailableSlot,
}: ExpertsListProps) => {
  const { t } = useLocale();

  return (
    <>
      <section id="experts">
        <div className="container py-12 md:py-32">
          {header && (
            <header className="mb-6 flex flex-wrap justify-between gap-3 md:mb-12">
              <h2 className="text-4xl md:text-5xl">{header}</h2>
              <Button size="2xl" color="secondary" EndIcon={FiArrowRight} href="/consultations/experts">
                {t("experts_see_all")}
              </Button>
            </header>
          )}
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-10">
            {experts
              ? experts.map((expert) => (
                  <ExpertCard
                    key={expert.id}
                    expert={expert}
                    booking={booking}
                    nextAvailableSlot={expert.username ? expertsNextAvailableSlot[expert.username] : null}
                  />
                ))
              : null}
          </div>
          {footer && <footer className="mt-12 flex">{footer}</footer>}
        </div>
      </section>
    </>
  );
};
